// Import third-party CSS first so our custom styles can override them
import 'bootstrap/dist/css/bootstrap.min.css';
import 'font-awesome/css/font-awesome.min.css';
import 'timepicker.js/dist/timepicker.min.css';
import 'timepicker.js/dist/timepicker.min.js';
import 'react-datepicker/dist/react-datepicker.css';

// Import our custom styles last to ensure they override third-party defaults
import './style';
import App from './components/app';

// Hand a native-app Untappd OAuth callback back to the mobile app BEFORE the
// SPA renders or the auth gate can redirect an unauthenticated in-app browser
// to the login page. Must run first. See services/untappdAppBounce.js.
import { handleUntappdAppBounce } from './services/untappdAppBounce';
handleUntappdAppBounce();

// Set up global auth error handling
import { setupAuthInterceptor } from './services/authInterceptor';
setupAuthInterceptor();

// Set up global API error handling to prevent unhandled rejections
import { setupApiErrorHandler } from './services/apiErrorHandler';
setupApiErrorHandler();

// Set up error logging for debugging blank screen issues
import './utils/errorLogger';

// Recover from stale lazy-route chunks after a deploy. A browser running the
// previous bundle requests a chunk hash that no longer exists; the SPA
// fallback returns index.html as 200/text/html, webpack chokes on '<', and the
// route renders blank. Reload once to pick up the current shell.
import { installChunkErrorRecovery } from './utils/chunkReload';
installChunkErrorRecovery();

export default App;
